/**
 * File: AslListenController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class AslListenController {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state, CONSTANTS,CQuesConst,$sce,Upload) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Archives"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
    var MQ = MathQuill.getInterface(2);
    let UPLOAD_URL = CONSTANTS.SERVER_UPLOAD
    let userId = localStorageService.get("user_id")
    let USER_PATH = userId + "/asl/"
    let schoolId = localStorageService.get("school_id")
    let ASL_ANS_TYPE=CQuesConst.ASL_ANS_TYPE
    let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
    let QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT
    let GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES
    let GET_PASSAGE = CQuesConst.API_GET_PASSAGE
    let SAVE_URL = CQuesConst.API_CREATE_ASL_LISTEN
        //Object - holds the question details
    $scope.asl = {};

    //[Object] - List of questions
    $scope.asl.questions = [];

    //String - Url to play audio
    $scope.playableQuestionUrl;

    //Boolean - Show add question section
    $scope.isAddQuestionAvail = true;

    $scope.editQuestions = [];

    $scope.convertedURL = {}
    $scope.questionImage = [];
    $scope.content_editor_id = userId;
    let question = $scope.$parent.$parent.editQuestion
    if (question) {
      $scope.question=question.qn_desc;
      $scope.asl.title = question.qn_desc;
      $scope.asl.qn_audio_url = question.audio_url;
      if (question.audio_url) {
        let src = PREVIEW_URL + question.audio_url
        $scope.playableQuestionUrl = $sce.trustAsResourceUrl(src)
      }
      if (question.questions&&question.questions.length > 0)
        $scope.asl.questions = question.questions ? question.questions : [];
      else {
        $scope.editQuestions.push({
          type: ASL_ANS_TYPE.AUDIO
        })
      }
    } else {
      $scope.editQuestions.push({
        type: ASL_ANS_TYPE.AUDIO
      })
    }

    /*
     * Function to add questions
     *
     * @return : null
     */
    $scope.addQuestion = () => {
      $scope.editQuestions.push({
        type: ASL_ANS_TYPE.AUDIO
      })
      $scope.isAddQuestionAvail = true
    }

    /*
     * Function to remove questions
     *
     * @return : null
     */
    $scope.removeQuestion = (index) => {
      $scope.asl.questions.splice(index, 1)
      if (($scope.asl.questions.length == 0) ||
        ($scope.editQuestions.length == 0)) {
        $scope.isAddQuestionAvail = true;
      }
    }

    /*
     * Function to edit questions
     *
     * @index : String - index of the item to removed
     *
     * @return : null
     */
    $scope.editQuestion = (index) => {
      $scope.editQuestions.push($scope.asl.questions[index])
      $scope.asl.questions.splice(index, 1)
      $scope.isAddQuestionAvail = true;
    }

    /*
     * Function to add to list
     *
     * @obj : Object - question to add
     *
     * @index : String - index
     *
     * @return : null
     */
    $scope.addToList = (obj, index) => {
      $scope.asl.questions.push(obj)
      $scope.editQuestions.splice(index, 1)
      if ($scope.editQuestions.length == 0) {
        $scope.isAddQuestionAvail = false;
      }
      $timeout(function() {
        var questionElements = document.getElementsByClassName('latex_field')
        _.each(questionElements, function(spanElement) {
          MQ.StaticMath(spanElement);
        })
      }, 10);
    }

    /*
     * Function to open menu
     *
     * @return : null
     */
    $scope.openMenu = function($mdOpenMenu, ev) {
      //originatorEv = ev;
      $mdOpenMenu(ev);
    };

    /*
     * Function to convert to trust url
     *
     * @url : String - url to convert
     *
     * @index : String - index of the url
     *
     * @return : null
     */
    $scope.convertURLTotrustUrl = function(url, index) {
      $scope.convertedURL[index] = $sce.trustAsResourceUrl(PREVIEW_URL + url);
    }

    /*
     * Function to upload audio
     *
     * @return : null
     */
    $scope.uploadAudio = (file) => {
      if (fileValidate(file)) {
        let user_id = userId
        Upload.upload({
          url: UPLOAD_URL,
          data: {
            file: file,
            'userPath': USER_PATH
          }
        }).then(function(resp) {
          updateAudioUrl(resp.data)
        })
      }
    }

    /*
     * Function to upload audio
     *
     * @return : null
     */
    function updateAudioUrl(url) {
      $scope.asl.qn_audio_url = url;
      let src = PREVIEW_URL + url
      $scope.playableQuestionUrl = $sce.trustAsResourceUrl(src)
      $scope.isLoading = true
      toastr.success("Audio uploaded successfully...")
    }

    /*
     * Function to validate audio files
     *
     * @file : uploaded file
     *
     * @return : Boolean - validity of file
     */
    function fileValidate(file) {
      let supportedFrmts = ['mp3', 'wav']
      let isValid = false

      if (file && !file.$error && file !== undefined && file !== null) {
        let fileSize = ((file.size) / 1048576)
        let extValue = file.name.split('.').pop();
        if (_.contains(supportedFrmts, extValue)) {
          // if (file.type === "audio/mp3" || file.type === "audio/wav") {
          if (fileSize < 6.00) {
            if (file.name !== "") {
              $scope.isLoading = false;
              isValid = true;
            } else {
              $scope.isLoading = true;
              toastr.error("File is not valid")
              isValid = false
            }
          } else {
            $scope.isLoading = true;
            toastr.error("Please upload audio file size less than 6MB")
            isValid = false
          };
        } else {
          $scope.isLoading = true;
          toastr.error('Please select supported mp3 or wav file formats.')
          isValid = false
        }
      }
      return isValid
    }

    /*
     * Function to save recorded file url
     *
     * @url : uploaded file url
     *
     * @return : null
     */
    $scope.saveRecordedUrl = (url) => {
      updateAudioUrl(url)
    }

    //Adding asl-listening question from UI
    $scope.$on('addAslListening', function() {
    
            let details = localStorageService.get("questionDetails")
            let question = details.question
            let activityErrorCount = details.errorCount;
      
      //Validation 
      $scope.errors = {};

      if ($scope.asl.title == undefined || $scope.asl.title == "" || $scope.asl.title == null) {
        activityErrorCount++;
        $scope.errors['qn_desc'] = "Question title is requrired"
      }
      if ($scope.asl.qn_audio_url == undefined || $scope.asl.qn_audio_url == "" || $scope.asl.qn_audio_url == null) {
        activityErrorCount++;
        $scope.errors["audio_url"] = "Upload a audio file"
      }
      if ($scope.asl.questions && $scope.asl.questions.length <= 0) {
        activityErrorCount++;
        $scope.errors['question'] = "Add atleast one question and answer for the audio"
      }
     
      if(activityErrorCount === 0){
        $scope.$parent.isSaveClicked = true;
        let obj = {
          "_id": $scope._id,
          "question_theme_id": question.theme._id,
          "question_theme_name": question.theme.name,
          "desc": $scope.desc,
          "audio_url": $scope.asl.qn_audio_url,
          "questions": angular.copy($scope.asl.questions),
          "strand": question.strand,
          "tag": question.tag,
          "wave": question.wave,
          "qn_desc": '' + $scope.question,
          "isLatex": $scope.isLatex,
          "level": question.level,
          "subject_id": question.subject_id,
          "school_id": question.school_id,
          "questionImg": $scope.questionImage,
          "session_id": question.session_id,
          "batch_id": question.batch_id,
          "class_id": question.class_id,
          "curriculum_id": question.curriculum_id,
          "xlink": question.link_theme,
          "cognitive_skills": question.cognitive_skill,
          "isNotAddToQp": question.isNotAddToQp,
          "is_traditional_activity": question.is_traditional_activity,
          "qp_id": question.qp_id,
          "activity_id": question.activity_id,
          "user_id": userId,
          "created_dt": $scope.created_dt,
          "content_editor_id": $scope.content_editor_id
        }
          //SAVE CALL
          authService.callAPI(SAVE_URL, "POST", obj, function(resObj) {
            let result = resObj.result
            if (result && result.data && result.data.success) {
                $rootScope.setHideSaveButton(false)
                $rootScope.setLoader(false)
                $rootScope.resetValues()
                if (question.is_traditional_activity) {
                    $state.go('formatQuestion', {
                        qpId: question.qp_id
                    })
                    toastr.success("Question Saved successfully");
                } else {
                    if (result.data.isExists) {
                        toastr.success("Question already exists");
                    } else {
                        toastr.success("Question Saved successfully");
                        $rootScope.setSearchFieldSession()
                    }
                }
            } else {
                $rootScope.setHideSaveButton(false)
                $rootScope.setLoader(false)
                toastr.error("Network Error")
            }
            _.defer(() => {
                $scope.$apply()
            })
        })
      }
      else {
        $rootScope.setHideSaveButton(false)
        $rootScope.setLoader(false)
        toastr.error("Please fill all mandatory fields")
    }
     })
        
        //On destroy function
        this.$onDestroy = () => {
        }

    }
}

export default AslListenController;


// WEBPACK FOOTER //
// ./src/app/createQuestion/controllers/aslListenController.js